import styled from 'styled-components';
import { LXbody } from '../../texts/lxText';
import Row from '../box/row';
import SizedBox from '../box/sizedBox';

interface LXStepProps {
  titles: string[];
  width: number;
  current: number;
}

interface LXStepContainerProps {
  width: number;
}

interface StepItemProps {
  isCurrent: boolean;
}

const StepNumberContainer = styled.div<StepItemProps>`
  width: 24px;
  height: 24px;
  background-color: ${(props) =>
    props.isCurrent && props.theme.colors.grayIcon};

  border: ${(props) =>
    !props.isCurrent && `1px solid ${props.theme.colors.grayLine}`};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  line-height: 18px;
  color: ${(props) =>
    props.isCurrent ? props.theme.colors.white : props.theme.colors.disabled};
`;

const StepBar = styled.div<StepItemProps>`
  height: 1px;
  flex-grow: 1;
  background-color: ${(props) =>
    props.isCurrent
      ? props.theme.colors.grayBgDark
      : props.theme.colors.grayLine};
`;

const StepTitle = styled(LXbody)<StepItemProps>`
  color: ${(props) =>
    props.isCurrent ? props.theme.colors.title : props.theme.colors.disabled};
`;

const StepContainer = styled.div<LXStepContainerProps>`
  width: ${(props) => `${props.width}px`};
`;

const LXStep: React.FC<LXStepProps> = (props) => {
  const buildItems = () => {
    return props.titles.map((title, idx) => {
      const isCurrent = idx === props.current;

      if (idx === 0) {
        return (
          <Row key={idx} alignItems="center" flexGrow={0}>
            <StepNumberContainer isCurrent={isCurrent}>
              {idx + 1}
            </StepNumberContainer>
            <SizedBox width={8}></SizedBox>
            <StepTitle isCurrent={isCurrent}>{title}</StepTitle>
            <SizedBox width={12}></SizedBox>
          </Row>
        );
      } else {
        return (
          <Row key={idx} alignItems="center" flexGrow={1}>
            <StepBar isCurrent={isCurrent}></StepBar>
            <SizedBox width={12}></SizedBox>
            <StepNumberContainer isCurrent={isCurrent}>
              {idx + 1}
            </StepNumberContainer>
            <SizedBox width={8}></SizedBox>
            <StepTitle isCurrent={isCurrent}>{title}</StepTitle>
            <SizedBox width={12}></SizedBox>
          </Row>
        );
      }
    });
  };

  return (
    <StepContainer width={props.width}>
      <Row>{buildItems()}</Row>
    </StepContainer>
  );
};

export default LXStep;
